export const DefaultRowsPerPageOptions = [15, 25, 50];
